module.exports = __webpack_public_path__ + "static/media/确认打包@2x.915e2bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/确认打包@2x.png
// module id = 402
// module chunks = 0